import React from 'react';
import { Building, WrenchHammer } from '@procore/core-icons';
import { Box, Typography } from '@mui/material';
import { Business } from '../../types/business';
import { useStyles } from './SimilarBusinessesCard.styles';
import BusinessMetadata from './BusinessMetadata';
import EmailObfuscationWrapper from '../utils/EmailObfuscationWrapper';

interface SimilarBusinessesCardProps {
  business: Business;
}

const SimilarBusinessesCard = ({ business }: SimilarBusinessesCardProps) => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignContent="flex-start"
      className={classes.wrapper}
      px={4}
      marginTop="32px"
      minWidth="240px"
      paddingLeft="0px"
      paddingRight="0px"
    >
      <Box display="flex" flexDirection="row" alignContent="center">
        <Typography variant="h2" className={classes.businessName}>
          <EmailObfuscationWrapper>{business.name}</EmailObfuscationWrapper>
        </Typography>
      </Box>
      <Box display="flex" flexDirection="row" alignContent="center" mt="5px">
        <BusinessMetadata
          data-test-id="construction-sectors"
          view="profile"
          Icon={Building}
          items={business.constructionSectors.sort((a, b) =>
            a.localeCompare(b)
          )}
          chopIndex={2}
        />
      </Box>
      {business.providedServices.length > 0 && (
        <Box>
          <BusinessMetadata
            data-test-id="provided-services"
            view="profile"
            Icon={WrenchHammer}
            items={business.providedServices
              .map((item) => item.name)
              .sort((a, b) => a.localeCompare(b))}
            chopIndex={4}
          />
        </Box>
      )}
    </Box>
  );
};

export default SimilarBusinessesCard;
